import { useInfiniteQuery } from "react-query";
import inventoryClient from "../clients/inventoryClient";

function useWasteLogsInfiniteScroll(establishmentId, enabled = true) {
  const queryReturnValues = useInfiniteQuery(
    ["waste-logs-infinite", { establishmentId }],
    ({ pageParam = 1 }) =>
      inventoryClient.getWasteLogsInfiniteScroll(establishmentId, pageParam),
    {
      enabled: Boolean(enabled),
      staleTime: 1000 * 60 * 5,
      keepPreviousData: true,
      getNextPageParam: (lastPage, allPages) => {
        const currentPage = allPages.length;
        return currentPage < lastPage.totalPages ? currentPage + 1 : undefined;
      },
    }
  );

  return queryReturnValues;
}

export default useWasteLogsInfiniteScroll;
